import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { DynamicPageData } from '../../providers/dynamic-page-data';

@Injectable()
// Share methods between Mobile and Full Web view
export class DynamicPageCommon {
	constructor(
		private dynamicPageData: DynamicPageData
	) {}

	public getPageData(pageId){
		var self = this;
		return self.dynamicPageData.getPageData(pageId);
	}	
}



// WEBPACK FOOTER //
// ./src/modules/dynamic-page/pages/dynamic-page/dynamic-page.common.ts